import resize from "./resize";

const collapse = () => {
  function collapseList(wrapper, btns, collapse, icon) {
    let wrap = document.querySelector(wrapper);

    if (wrap) {
      let buttons = wrap.querySelectorAll(btns),
        collapseBlock = wrap?.querySelectorAll(collapse);

      buttons.forEach((item, i) => {
        let ul = collapseBlock[i].querySelector('ul');
        collapseBlock[i].style.height = 0;

        item.addEventListener("click", (e) => {
          if (window.innerWidth <= 767) {
            e.stopImmediatePropagation();

            if (collapseBlock[i].style.height == 0 + "px") {
              collapseBlock[i].style.height = ul.clientHeight + 10 + "px";
              item.querySelector(icon).classList.add("rotate");
            } else {
              collapseBlock[i].style.height = 0;
              item.querySelector(icon).classList.remove("rotate");
            }
          }
        });
      });
    }
  }

  function resizeCollapse() {
    if (window.innerWidth <= 767) {
      collapseList(
        ".footer__item-list--1",
        ".footer__item-list__title",
        ".footer__item-list__collapse",
        ".footer__item-list__title-icon"
      );
      collapseList(
        ".footer__item-list--2",
        ".footer__item-list__title",
        ".footer__item-list__collapse",
        ".footer__item-list__title-icon"
      );
      collapseList(
        ".footer__item-list--3",
        ".footer__item-list__title",
        ".footer__item-list__collapse",
        ".footer__item-list__title-icon"
      );
    }
  }

  resizeCollapse();
  resize(resizeCollapse);
};

export default collapse;
